import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IConvo } from '../../../model/convo'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchTags from './fetch-tags'

export default async function addConvoTag(context: BareActionContext<ConvoState, RootState>, convo: IConvo) {
  if (convo.meta) {
    const newTag = convo.meta.newTag
    if (newTag) {
      convoUtils.convoService.addTag(convo, newTag).then((result: any) => {
        convoStore.commitResetConvoTag({ convo: convo })
        fetchTags(context, convo)
      })
    }
  }

  return
}
